export default "__VITE_ASSET__6f157d65__"